import styled from 'styled-components';

export const Overlay = styled.div<{ $top?: number; $zIndex?: number }>`
  position: fixed;
  top: ${({ $top }) => ($top ? `${$top}px` : '0')};
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: ${({ $zIndex }) => ($zIndex ? $zIndex : '3')};
`;
